import { LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/authContext';
import SidebarItem from './SidebarItem';

export default function Sidebar({ sidebarLinks, children, sidebarTitle="Admin Panel" }) {
  let { user, logout } = useAuth();

  return (
    <div>
      {/* Drawer */}
      <div className="drawer lg:drawer-open">
        <input
          className="drawer-toggle"
          id="admin-drawer"
          type="checkbox"
        />

        <div className="drawer-content flex flex-col">
          {/* Page content here */}
          <div className="p-4">
            {/* Mobile Drawer Trigger */}
            <div className="w-ful flex flex-col p-0 md:px-4">
              <label htmlFor="admin-drawer" className="btn btn-ghost lg:hidden w-fit ps-0">
                <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path clipRule="evenodd" fillRule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
                </svg>
              </label>
              {children}
            </div>
          </div>
        </div>

        <div className="drawer-side md:p-4 md:pe-0">
          <label
            className="drawer-overlay"
            htmlFor="admin-drawer"
          ></label>

          {/* actual sidebar content */}
          <div className="menu p-4 w-80 max-w-full min-h-full md:min-h-[calc(100vh-80px)] rounded-2xl bg-base-100 text-base-content">
            {/* Sidebar content */}
            <div className="flex flex-col ">
              {/* Logo */}
              <div className="flex items-center gap-3 px-2 py-4 mb-6">
                <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
                  <span className="text-primary-content font-bold text-xl">A</span>
                </div>
                <span className="text-xl font-bold">{sidebarTitle}</span>
              </div>

              {/* Navigation Links */}
              <ul className="space-y-2 grow">
                {sidebarLinks.map((link) => (
                  link.subLinks ? (
                  <li key={link.title} >
                    <details>
                      <summary className="flex gap-4 px-4 py-3 items-center cursor-pointer collapse-arrow after:ml-auto">
                        {link.icon}
                        <span>{link.title}</span>
                      </summary>
                      <ul className="pl-4 space-y-2">
                        {link.subLinks.map((subLink) => (
                          <SidebarItem key={subLink.title} link={subLink} />
                        ))}
                      </ul>
                    </details>
                  </li>
                  ) : (
                    <SidebarItem key={link.title} link={link} />
                  )
                ))}
              </ul>

              {/* User Section - Bottom */}
              <div className="mt-auto">
                <div className="divider"></div>
                <div className="flex items-center gap-4 px-2 py-4">
                  <div className="avatar">
                    <div className="w-10 rounded-full">
                      <img src="https://img.daisyui.com/images/stock/photo-1534528741775-53994a69daeb.webp" alt="User avatar" />
                    </div>
                  </div>
                  <div>
                    <h4 className="font-semibold capitalize">{user.first_name} {user.last_name}</h4>
                    <p className="text-sm text-base-content/70">{user.is_admin ? 'Administrator' : 'Dashboard'}</p>
                  </div>
                  <button onClick={logout} className="btn btn-ghost btn-square ml-auto" >
                    <LogOut 
                      className="w-5 h-5" 
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
